// ABOUTME: The modal asking a participant to confirm cancelling one Nylas-booked coaching session
// ABOUTME: It cannot be closed while the cancel is in flight, so a cancel the server makes is seen
import { Modal, ModalBody, ModalHeader } from '@execonline-inc/execonline-ui';
import { CancelSession, CancelView, Moving } from '@execonline-inc/slot-picker.private';
import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useTranslationsContext } from '../../Translations/UseTranslationsContext';
import { request } from './request';
import { cancelSessionText } from './text';

interface Props {
  cancelHref: string;
  session: Moving;
  timeZone: string;
  locale: string;
  onCancelled: () => void;
  onClose: () => void;
}

const CancelSessionModal = ({
  cancelHref,
  session,
  timeZone,
  locale,
  onCancelled,
  onClose,
}: Props) => {
  const { ts } = useTranslationsContext();
  const text = cancelSessionText(ts);
  const [view, setView] = useState<CancelView>('confirming');
  const cancelling = view === 'cancelling';
  const dismiss = () => {
    if (!cancelling) {
      onClose();
    }
  };

  return (
    <Modal
      open={true}
      size="xl"
      onClose={dismiss}
      escapeKey={!cancelling}
      classNames={{ closeButton: cancelling ? 'hidden' : '' }}
    >
      {/* The confirmation has its own visible heading; screen readers name the dialog by this. */}
      <ModalHeader className="sr-only">
        <h2>{text.heading}</h2>
      </ModalHeader>
      <ModalBody className="py-10 sm:py-10 sm:pt-12">
        <CancelSession
          cancelHref={cancelHref}
          request={request}
          text={text}
          locale={locale}
          session={session}
          timeZone={timeZone}
          sessionWith={nothing()}
          onCancelled={onCancelled}
          onViewChange={setView}
          onClose={onClose}
        />
      </ModalBody>
    </Modal>
  );
};

export default observer(CancelSessionModal);
